export default __webpack_public_path__ + "media/color/matic-5aa7e444.svg";